import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import GoogleAdPreviewSearch1 from '../../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewSearch1'
import MultipleOptionsField from '../../../../ReusableFormFields/MultipleOptionsField'

import { headlineMaxLength, HEADLINES_LIST } from '../../fields'

import useStyles from '../../styles'

function HeadlinesFields({ formik, adPreviewValues, showPreview = true }) {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <>
      <p>
        {t(
          'The headline is the first line of your ad and can be up to 30' +
            ' characters. Add up to five headlines that will be combined with your other assets to generate your ads.'
        )}
      </p>
      <p>
        Consider including text about your products or services (e.g. <i>“Bouquets from Local Growers”</i>), benefits
        (e.g.
        <i>“Hassle-Free Meals in 30 Mins”</i>) or call to action (e.g. “Book Your Hotel in Las Vegas”)
      </p>
      {showPreview && adPreviewValues && (
        <div className={classes.previewWrapper}>
          <GoogleAdPreviewSearch1 values={adPreviewValues} />
        </div>
      )}
      <MultipleOptionsField
        fieldLabel="Headline"
        fieldMaxLength={headlineMaxLength}
        listFieldName={HEADLINES_LIST}
        formik={formik}
        minListQuantity={3}
      />
    </>
  )
}

HeadlinesFields.propTypes = {
  formik: PropTypes.object,
  adPreviewValues: PropTypes.object
}

export default HeadlinesFields
